import { render } from "./CadastroBairrosView.vue?vue&type=template&id=d31e3622"
import script from "./CadastroBairrosView.vue?vue&type=script&lang=js"
export * from "./CadastroBairrosView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Domus Fiança\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__